import { Button } from "@mui/material";
import { useContext, useState } from "react";
import CreateCompanyModal from "../../components/Modal/CreateCompany/CreateCompanyModal";
import CompaniesTable from "../../components/Tables/CompaniesTable/CompaniesTable";
import { Context } from "../../context/context";

export default function Companies() {
  const { sidebar } = useContext(Context);
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && <CreateCompanyModal setOpen={setOpen} open={open} />}
      <main className={sidebar ? "container" : "container-full"}>
        <Button
          size="medium"
          onClick={() => setOpen(true)}
          style={{ width: "250px" }}
          variant="contained"
          className="new-user"
        >
          Cadastrar nova empresa
        </Button>

        <div className="table-container">
          <CompaniesTable />
        </div>
      </main>
    </>
  );
}
